/**
 * @file 门店字段
 * @author fuqiang15
 */

import FormModel from '@baidu/ve-ria/views/FormModel';

export default class StoreServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    formData = {
        name: '',
        identify: '',
        type: null
    };

    crumbData = [];

    importUrl = {
        create: '/data/app/service/map/store/import/create',
        update: '/data/app/service/map/store/import/update'
    };

    excelUrl = {
        create: '/data/app/service/map/store/excel/create',
        update: '/data/app/service/map/store/excel/update'
    };

    requiredFieldDescList = [
        {
            name: '名称',
            identify: 'title',
            type: 3
        },
        {
            name: '省份',
            identify: 'province',
            type: 3
        },
        {
            name: '市',
            identify: 'city',
            type: 3
        },
        {
            name: '地址',
            identify: 'address',
            type: 3
        },
        {
            name: '电话',
            identify: 'mobile',
            type: 3
        },
        {
            name: '一级行业',
            identify: 'lv_one_indus',
            type: 3
        },
        {
            name: '二级行业',
            identify: 'lv_two_indus',
            type: 3
        },
        {
            name: '照片',
            identify: 'img_url',
            type: 4
        }
    ];

    fieldTypeDatasource = this.getConstantDatasource('APP_SERVICE_MAP_FIELD_TYPE');
    fieldTypeMap = this.getConstantMap('APP_SERVICE_MAP_FIELD_TYPE');

    operationTypeDatasource = [
        {label: '创建', value: 'create'},
        {label: '更新', value: 'update'}
    ];

    operationType = 'create';

    serviceId = null;
    tableDetail = {};

    setRequesters() {
        if (this.pageType === 'edit') {
            // 这里是把上面的增加field看成form
            this.updateRequester = this.api.appServiceMapStoreFieldCreate;
            this.detailRequester = this.api.appServiceMapStoreTableInfo;
            this.updateFieldRequester = this.api.appServiceMapStoreFieldUpdate;
            this.deleteFieldRequester = this.api.appServiceMapStoreFieldDelete;
            this.publishRequester = this.api.appServicePublish;
        }
        else if (this.pageType === 'detail') {
            this.detailRequester = this.api.appServiceMapStoreTableInfo;
        }
    }

    init() {
        super.init();
        this.setRequesters();
        this.setCrumbData();

        this.serviceId = this.getRouteParams().serviceId;
        this.isAdmin = !!this.getRouteMeta().isAdmin;
    }

    getDefaultArgs() {
        return {
            serviceId: this.serviceId
        };
    }

    setCrumbData() {
        let appId = this.getRouteParams().appId;
        appId = appId ? `${appId}/` : '';
        let action = this.getConstantMap('PAGE_TYPE')[this.pageType];
        this.crumbData = [
            {
                text: '服务管理',
                to: `/app/${appId}service/list`
            },
            {text: `${action}地图服务`}
        ];
    }

    requestDeleteStoreField(id) {
        return this.deleteFieldRequester({
            id,
            serviceId: this.serviceId
        });
    }

    requestUpdateStoreField({id, name}) {
        return this.updateFieldRequester({
            id,
            name,
            serviceId: this.serviceId
        });
    }

    requestPublish() {
        return this.publishRequester({id: this.serviceId});
    }

    prepareData(data) {
        return {...data, serviceId: this.serviceId};
    }

    adaptData(data) {
        this.tableDetail = data;
    }
}
